import type { SelectorDefinition } from '@exodus/redux-dependency-injection';

import type { Data } from '../initial-state.js';

const resultFunction = (data: Data) => data.installCalloutVisible;

const installCalloutVisibleDefinition = {
  id: 'installCalloutVisible',
  resultFunction,
  dependencies: [
    //
    { selector: 'data' },
  ],
} as const satisfies SelectorDefinition;

export default installCalloutVisibleDefinition;
